import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostLimitCreationFailedAction = {
	type: 'AI_COST_LIMIT_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostLimitCreationFailedAction => ({
	type: 'AI_COST_LIMIT_CREATION_FAILED',
	payload,
});
